
const CardFunctions = {
  getEventIcon (eventType) {
    const type = eventType.split('.')[0]
    const icons = {
      shipment: 'el-icon-box',
      account: 'el-icon-user',
      profile: 'el-icon-user-solid',
      document: 'el-icon-document',
      invoice: 'el-icon-tickets',
      payment: 'el-icon-money'
    }
    return icons[type] || 'el-icon-info'
  },
  getEventColor (eventType) {
    const action = eventType.split('.')[1]
    const colors = {
      created: '#67C23A',
      updated: '#409EFF',
      deleted: '#F56C6C',
      delivered: '#67C23A',
      in_transit: '#E6A23C',
      delayed: '#F56C6C',
      suspended: '#F56C6C',
      uploaded: '#409EFF',
      approved: '#67C23A',
      rejected: '#F56C6C',
      cancelled: '#909399'
    }
    return colors[action] || '#909399'
  },
  getStatusType (status) {
    const types = {
      active: 'success',
      pending: 'warning',
      in_transit: 'primary',
      delivered: 'success',
      delayed: 'danger',
      suspended: 'danger',
      pending_review: 'warning',
      cancelled: 'info',
      approved: 'success',
      rejected: 'danger',
      completed: 'success'
    }
    return types[status] || ''
  },
  formatEventType (eventType) {
    return eventType
      .split('.')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).replace(/_/g, ' '))
      .join(' - ')
  },
  formatDate (dateString) {
    const date = new Date(dateString)
    const now = new Date()
    const diff = now - date
    const minutes = Math.floor(diff / 60000)
    const hours = Math.floor(diff / 3600000)
    const days = Math.floor(diff / 86400000)

    if (minutes < 1) return 'Just now'
    if (minutes < 60) return `${minutes}m ago`
    if (hours < 24) return `${hours}h ago`
    if (days < 7) return `${days}d ago`

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    })
  },
  formatKey (key) {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase())
  },
  formatValue (value) {
    if (Array.isArray(value)) {
      return value.join(', ')
    }
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value)
    }
    return value
  }
}

export default CardFunctions
